import { ImsPermissions } from "@redotech/account-common/permissions";
import { RedoSecondaryNavItem } from "@redotech/arbiter/navigation/secondary/redo-secondary-nav-item";
import { useRequiredContext } from "@redotech/react-util/context";
import { useTranslation } from "@redotech/redo-i18n";
import FlipForwardIcon from "@redotech/redo-icons/flip-forward.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { memo } from "react";
import { useMatch } from "react-router-dom";

export const TransfersItem = memo(function TransfersItem({
  hidden,
}: {
  hidden?: boolean;
}) {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const urlPrefix = `${routes.inventoryManagementBaseUrl}/transfers`;

  const hasPermissionToViewItem = useHasPermission(
    ImsPermissions.ACCESS_TRANSFERS,
  );

  const anyChildSelected = useMatch(`${urlPrefix}/*`);

  if (!hasPermissionToViewItem) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: urlPrefix }}
      anyChildSelected={!!anyChildSelected}
      FilledIcon={FlipForwardIcon}
      friendlyName={t("Transfers", {
        context: "inventory navigation label for warehouse stock movements",
      })}
      hidden={hidden}
      id="transfers"
      UnfilledIcon={FlipForwardIcon}
    />
  );
});
